export const admissionProcessTabs = [
  {
    id: "on-campus",
    name: "on-campus",
  },
  {
    id: "online",
    name: "online",
  },
  {
    id: "short-courses",
    name: "short courses",
  },
];

export const admissionProcessStepsOnCampus = {
  stepOne: "Send Scanned Copies of your Document",
  stepTwo: "Send Scanned Copies of your Document",
  stepThree: "Send Scanned Copies of your Document",
  stepFour: "Send Scanned Copies of your Document",
  stepFive: "Send Scanned Copies of your Document",
};

export const admissionProcessStepsOnline = {
  stepOne: "Send Scanned Copies of your Document2",
  stepTwo: "Send Scanned Copies of your Document2",
  stepThree: "Send Scanned Copies of your Document2",
  stepFour: "Send Scanned Copies of your Document2",
  stepFive: "Send Scanned Copies of your Document2",
};

export const admissionProcessStepsShortCourses = {
  stepOne: "Send Scanned Copies of your Document3",
  stepTwo: "Send Scanned Copies of your Document3",
  stepThree: "Send Scanned Copies of your Document3",
  stepFour: "Send Scanned Copies of your Documen3t",
  stepFive: "Send Scanned Copies of your Document3",
};
